var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2755 35.1929L12.9597 27.8779C12.4991 27.4174 12.4991 26.6706 12.9597 26.2099C13.4207 25.7488 14.1672 25.7488 14.6277 26.2099L20.2755 31.8572L35.3734 16.7589C35.8345 16.2978 36.5809 16.2978 37.0414 16.7589C37.5026 17.2194 37.5026 17.9664 37.0414 18.4269L20.2755 35.1929Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0028 50.5587V49.3791L25.001 50.5587C11.2163 50.5587 0.000980402 39.3439 0 25.5592C0 11.774 11.2153 0.558716 25 0.558716C38.7852 0.558716 50 11.774 50 25.5587C50.0005 39.3439 38.7866 50.5587 25.0028 50.5587ZM25 2.91805C12.5158 2.91805 2.35934 13.0745 2.35934 25.5587C2.36032 38.0424 12.5172 48.1989 25.001 48.1989H25.0028C37.4856 48.1989 47.6412 38.0424 47.6412 25.5587C47.6412 13.0745 37.4842 2.91805 25 2.91805Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.558716)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.720e97dfb890718c18f25c64ea0da5eb.svg";
export { ForwardRef as ReactComponent };